import type {
  ReservationSlotSettings,
  ReservationSlotSettingsInput,
} from '../../domain/reservationSlots';
import type { ReservationSlotSettingsRepository } from './ports/ReservationSlotSettingsRepository';

/**
 * 解放枠の基本設定を更新するUseCase
 *
 * @param {ReservationSlotSettingsRepository} repository - Repository実装（DI）
 * @param {ReservationSlotSettingsInput} input - 入力データ（overridesは全置換）
 * @returns {Promise<ReservationSlotSettings>} 更新後の基本設定
 */
export async function updateSettings(
  repository: ReservationSlotSettingsRepository,
  input: ReservationSlotSettingsInput
): Promise<ReservationSlotSettings> {
  return repository.update(input);
}
